import classNames from "classnames";
import { TRANSACTION_COLUMNS } from "constants/transaction";
import { Cell, flexRender, Row } from "react-table-8.10.7";
import { RulesData } from "types/Models/ruleEngine";

type MobileRuleRowProps = {
  row: Row<RulesData>;
  isDisabled: boolean;
  isPreviewed: boolean;
  onClick: () => void;
};

// Column ids set on the column helpers in RuleEngine.
const RULE_COLUMN_ID = {
  TITLE: "name",
  CONDITIONS: "conditions",
  CATEGORY: "category",
  TYPE: "source",
  OPTIONS: TRANSACTION_COLUMNS.OPTIONS,
} as const;

const renderCell = (cell?: Cell<RulesData, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileRuleRow = ({
  row,
  isDisabled,
  isPreviewed,
  onClick,
}: MobileRuleRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  return (
    <div
      onClick={onClick}
      className={classNames(
        "t-flex t-flex-col t-gap-3 t-border-0 t-border-b t-border-solid t-border-neutral-0 t-py-3 last:t-border-b-0",
        {
          "t-bg-surface-lighter-grey": isPreviewed,
          "t-cursor-pointer t-text-text-100": !isDisabled,
          "t-text-text-30": isDisabled,
        }
      )}
    >
      <div className="t-flex t-items-start t-justify-between t-gap-3">
        <span
          className={classNames("t-min-w-0 t-text-subtext t-break-words", {
            "t-opacity-50": isDisabled,
          })}
        >
          {renderCell(cellsById[RULE_COLUMN_ID.TITLE])}
        </span>
        <div className="t-flex t-shrink-0 t-items-center t-gap-1">
          <div className={classNames({ "t-opacity-50": isDisabled })}>
            {renderCell(cellsById[RULE_COLUMN_ID.TYPE])}
          </div>
          {renderCell(cellsById[RULE_COLUMN_ID.OPTIONS])}
        </div>
      </div>

      <div className={classNames({ "t-opacity-50": isDisabled })}>
        {renderCell(cellsById[RULE_COLUMN_ID.CONDITIONS])}
      </div>

      <div
        className={classNames("t-flex t-flex-col t-gap-1 t-text-body-sm", {
          "t-opacity-50": isDisabled,
        })}
      >
        <span className="t-text-text-30">Category</span>
        <span>{renderCell(cellsById[RULE_COLUMN_ID.CATEGORY])}</span>
      </div>
    </div>
  );
};
